export default __webpack_public_path__ + "static/media/qqqr.8bf4d8cf.png";